// extracted by mini-css-extract-plugin
export default {"discountPriceContainer":"DiscountPrice-discountPriceContainer_AVImO","discountPrice":"DiscountPrice-discountPrice_WejgF"};